import { render, staticRenderFns } from "./input-discussion.vue?vue&type=template&id=743bdcf4"
import script from "./input-discussion.vue?vue&type=script&lang=js"
export * from "./input-discussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports